/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FeatureAccordionComponentEditor } from "cms/components/components/feature-accordion/edit";
import { FeatureAccordionComponentDisplay } from "cms/components/components/feature-accordion/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const FeatureAccordionComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <FeatureAccordionComponentDisplay />,
        editComponent: <FeatureAccordionComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

FeatureAccordionComponent.displayName = "FeatureAccordionComponent";
export { FeatureAccordionComponent };
